import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';

import { SingleSelectQuickflowsComponent } from './components/single-select-quickflows.component';
import { MultiSelectQuickflowsComponent } from 'QuickflowsApp/ts/features/quickflows-menu/components/multi-select-quickflows.component';
import { QuickflowsMenuComponent } from 'QuickflowsApp/ts/features/quickflows-menu/components/quickflows-menu.component';

@NgModule({
    imports: [CommonModule, IconModule, IconSearchAutocompleteModule, TooltipModule],
    declarations: [MultiSelectQuickflowsComponent, QuickflowsMenuComponent, SingleSelectQuickflowsComponent],
    exports: [QuickflowsMenuComponent],
})
export class QuickflowsMenuModule {}
